export default function RightArrow() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37672 6.06753C9.06884 5.79044 8.59462 5.81539 8.31753 6.12328C8.04044 6.43116 8.06539 6.90538 8.37328 7.18247L9.37672 6.06753ZM12.625 10L13.1267 10.5575C13.2848 10.4152 13.375 10.2126 13.375 10C13.375 9.78738 13.2848 9.58476 13.1267 9.44253L12.625 10ZM8.37328 12.8175C8.06539 13.0946 8.04044 13.5688 8.31753 13.8767C8.59462 14.1846 9.06884 14.2096 9.37672 13.9325L8.37328 12.8175ZM18.25 10C18.25 14.5563 14.5563 18.25 10 18.25V19.75C15.3848 19.75 19.75 15.3848 19.75 10H18.25ZM10 18.25C5.44365 18.25 1.75 14.5563 1.75 10H0.25C0.25 15.3848 4.61522 19.75 10 19.75V18.25ZM1.75 10C1.75 5.44365 5.44365 1.75 10 1.75V0.25C4.61522 0.25 0.25 4.61522 0.25 10H1.75ZM10 1.75C14.5563 1.75 18.25 5.44365 18.25 10H19.75C19.75 4.61522 15.3848 0.25 10 0.25V1.75ZM8.37328 7.18247L12.1233 10.5575L13.1267 9.44253L9.37672 6.06753L8.37328 7.18247ZM12.1233 9.44253L8.37328 12.8175L9.37672 13.9325L13.1267 10.5575L12.1233 9.44253Z"
        fill="currentColor"
      />
    </svg>
  );
}
